import styled from 'styled-components';
import { motion, type Variants, Transition } from 'framer-motion';

const Book = styled(motion.div)`
  position: absolute;
  width: 59px;

  .book-image {
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const Book1 = styled(Book)`
  box-shadow: 0px 7.63px 10.17px 0px #3042780f, 0px 5.08px 7.63px 0px #3042780f,
    0px 1.27px 2.54px 0px #3042780f;
  z-index: 7;
`;

export const Book2 = styled(Book)`
  box-shadow: 0px 7.28px 9.7px 0px #3042780f, 0px 4.85px 7.28px 0px #3042780f,
    0px 1.21px 2.43px 0px #3042780f;
  z-index: 8;
`;

export const Book3 = styled(Book)`
  box-shadow: 0px -2.52px 10.09px 0px #3295460d, 0px -1.89px 7.57px 0px #3295460d,
    0px -0.63px 3.15px 0px #3295460d;
  z-index: 9;
`;

const bookTransition: Transition = {
  duration: 0.3,
  ease: 'easeOut',
};

export const bookWrapperVariants: Variants = {
  hidden: {
    transition: {
      staggerChildren: 0.075,
    },
  },
  visible: {
    transition: {
      staggerChildren: 0.075,
    },
  },
};
export const book1Variants: Variants = {
  hidden: {
    left: 97,
    bottom: -3,
    x: '-50%',
    rotateZ: 3.71,
    transition: bookTransition,
  },
  visible: {
    left: 98,
    bottom: 16,
    x: '-50%',
    rotateZ: 3.71,
    transition: bookTransition,
  },
};

export const book2Variants: Variants = {
  hidden: {
    left: 87,
    bottom: -10,
    x: '-50%',
    rotateZ: 1.97,
    transition: bookTransition,
  },
  visible: {
    left: 74,
    bottom: 30,
    x: '-50%',
    rotateZ: -2.14,
    transition: bookTransition,
  },
};

export const book3Variants: Variants = {
  hidden: {
    left: 79,
    bottom: -19,
    x: '-50%',
    rotateZ: -6.77,
    transition: bookTransition,
  },
  visible: {
    left: 61,
    bottom: 7,
    x: '-50%',
    rotateZ: -24.32,
    transition: bookTransition,
  },
};
